module.exports = __webpack_public_path__ + "img/video-play.62a4c695.svg";